import { render, staticRenderFns } from "./SystemList.vue?vue&type=template&id=3137e0b3&scoped=true&"
import script from "./SystemList.vue?vue&type=script&lang=js&"
export * from "./SystemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3137e0b3",
  null
  
)

export default component.exports